import { render, staticRenderFns } from "./Quill.vue?vue&type=template&id=32defe04"
import script from "./Quill.vue?vue&type=script&lang=js"
export * from "./Quill.vue?vue&type=script&lang=js"
import style0 from "./Quill.vue?vue&type=style&index=0&id=32defe04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports